<template>
  <div>
    <span v-html="text" v-if="!isFormElement"></span>
    <component
      v-if="isFormElement"
      :is="formElementComponent"
      :name="uniqueFormElementName"
      v-model="innerValue"
      :options="formElementOptions"
      v-bind="formElementProperties"
      :errors="errors"
      :trajectory-enrolment="trajectoryEnrolment"
      :action-progress="actionProgress"
      :action-progress-id="actionProgressId"
      :check="check"
      :check-id="checkId"
      @send-event-to-component="sendEventToComponent"
    />
  </div>
</template>

<script>
import ValueForwarder from "~/mixins/value-forwarder";
import Select from "./select";
import Text from "./text";
import TextArea from "./textarea";
import Datepicker from "./datepicker";
import Checkbox from "./checkbox";

export default {
  name: "placeholder",
  mixins: [ValueForwarder],

  props: {
    text: {
      required: true,
    },
    actionDocumentFieldNames: {
      required: true,
    },
    errors: {
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    trajectoryEnrolment: {
      type: Object,
      required: false,
    },
    actionProgress: {
      type: Object,
      required: false,
    },
    actionProgressId: {
      type: Number,
      required: false,
    },
    check: {
      type: Boolean,
      default: false,
    },
    checkId: {
      type: Number,
      required: false,
    },
  },

  data() {
    return {
      regex: /^\[form\.([a-zA-Z_]+)\.([a-zA-Z0-9]+)\]$/i,
    };
  },

  components: {
    "ad-select": Select,
    "ad-text": Text,
    "ad-textarea": TextArea,
    "ad-datepicker": Datepicker,
    "ad-checkbox": Checkbox,
  },
  methods: {
    sendEventToComponent(event) {
      this.$emit('send-event-to-form', event);
    }
  },

  computed: {
    regexMatchesText() {
      return this.regex.exec(this.text);
    },

    formElementTypeName() {
      if (this.regexMatchesText !== null) {
        return this.regexMatchesText[1];
      }

      return null;
    },

    uniqueFormElementName() {
      if (this.regexMatchesText !== null) {
        return this.regexMatchesText[2];
      }

      return null;
    },

    isFormElement() {
      return (this.regexMatchesText || []).length === 3;
    },

    formElementData() {
      return this.actionDocumentFieldNames.find(
        (fieldName) => fieldName.name === this.uniqueFormElementName
      );
    },

    formElementComponent() {
      if (
        this.formElementData &&
        this.formElementData.action_document_field_element
      ) {
        return "ad-" + this.formElementData.action_document_field_element.type;
      }

      return "";
    },

    formElementProperties() {
      let defaultProperties = this.disabled ? { disabled: true } : {};
      if (
        this.formElementData &&
        this.formElementData.action_document_field_element
      ) {
        return (
          this.formElementData.action_document_field_element.properties ||
          defaultProperties
        );
      }

      return defaultProperties;
    },

    formElementOptions() {
      if (
        this.formElementData &&
        this.formElementData.action_document_field_element
      ) {
        return this.formElementData.action_document_field_element.options || {};
      }

      return {};
    },
  },
  watch: {
    innerValue(newVal, oldVal) {
      if (oldVal !== null) {
        this.$emit('form-dirty-inner', true); 
      }
    }
  },
};
</script>

<style scoped></style>
